export default "__VITE_ASSET__CHK4P0Ps__"